import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OrdersResponse } from "../interfaces/orders-user.interface";
import { Observable } from "rxjs";
import { AuthService } from "../../../core/service/auth.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class OrdersUserService {
  constructor(private http: HttpClient,
    private authService: AuthService,
  ) {

  }
  getOrders(): Observable<OrdersResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.authService.getToken()}`
    });

    return this.http.get<OrdersResponse>(`${environment.apiUrl}/orders`, { headers });
  }

}
